var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.description)?_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_c('p',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.detail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }